import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Radio, Input, Tooltip, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSubkindList } from "../../../../store/actions/precog/assets";
import { useDispatch } from "react-redux";
import numeral from "numeral";

import "./style.css";

/**
 * Fields for asset assignment and revocation in drawer footer
 * This is an array components
 * @returns
 */
const FirstRegistryFieldsDrawerFields = ({ editable, setEditable, setModifiedFields, 
  modifiedFields, readOnly=false, setIsDrawerAccountsDetail, setFieldsToDelete, parentId}) => {
  const dispatch = useDispatch();
  const [subkindOptions, setSubkindOptions] = useState([]);
  const [fixedDescription, setFixedDescription] = useState(null);
  const [editableDescription, setEditableDescription] = useState(null);

  useEffect(()=>{
    
    if (editable.kind && editable.group)
      dispatch(getSubkindList(editable.group, editable.kind))
        .then(res =>{
          setSubkindOptions(res);
        });
    if (editable?.assetFullDescription) {
      const splittedDesc = editable.assetFullDescription.split("~");
      setFixedDescription(splittedDesc[0]);
      setEditableDescription(splittedDesc[1]);
    }
  }, [editable]);

  return (
    <>
      <div className="pre-cog-assets-drawer-titles">
        <FormattedMessage id={"preCog.assetsTab.drawer.identificationData"} />
      </div>
      <div className="pre-cog-assets-drawer-section" style={{flexDirection: "row"}}>
        <div style={{ display: "flex", flexDirection: "column", width: "50%", gap: 24 }}>
          <div style={{ display: "flex" }}>
            <div className="pre-cog-assets-drawer-identification-subsection" style={{width: parentId ? "65%" : "50%"}}>
              {parentId ? 
                <div>
                  <div className="precog-withholding-drawer-form—label-text">Nome cespite</div>
                  <Input
                    value={editable.articleDesc}
                    className={"inputCustom drawer-inputCustom"}
                    style={{ marginBottom: 10 }}
                    onChange={e => {
                      setEditable({...editable, articleDesc: e.target.value});
                    }}
                    onBlur={() => {
                      if (editable.articleDesc) {
                        setModifiedFields({ ...modifiedFields, articleDesc: editable.articleDesc });
                      } else {
                        setFieldsToDelete(["articleDesc"]);
                      }
                    }}
                  />
                </div>
                :
                <div className="pre-cog-assets-drawer-conto-title"> 
                  {editable.articleDesc} 
                </div>
              }
            
              <div className="pre-cog-assets-drawer-subspecies"
                onClick={() => {setIsDrawerAccountsDetail(true);}}>
                {editable.accountDesc} 
              </div>
              <div className="pre-cog-assets-drawer-subtitles"> {editable.accountCode} </div>
            </div>
            <div className="pre-cog-assets-drawer-identification-subsection" 
              style={{ alignItems: "flex-start", paddingLeft: "16px", width: parentId ? "35%" : "50%" }}>
              <div>
                <div className="pre-cog-assets-drawer-subtitles" > <FormattedMessage id="preCog.assetsTab.drawer.amount" /> </div>
                <div className="pre-cog-assets-drawer-conto-amount"> {numeral(Math.abs(editable.amount)).format("0,0.00")} € </div>              
              </div>
              {(editable.hasAdditionalCharge || editable.additionalCharge !== undefined) &&
              <div>
                <div className="pre-cog-assets-drawer-subtitles">Spese accessorie</div>
                <div>
                  {numeral(Math.abs(editable.additionalCharge)).format("0,0.00")} €
                </div>
              </div>
              }
            </div>
          </div>

          <div>
            <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center", gap: 16, paddingBottom: 8 }}>
              <FormattedMessage id={"preCog.assetsTab.drawer.alias"} />
              <div className="precog-withholding-drawer-form—label-tooltip">
                <Tooltip
                  color={"rgb(0, 80, 117)"}
                  placement="leftBottom"
                  title={
                    <FormattedMessage
                      id={"preCog.assetsTab.tooltips.alias"}
                    />
                  }
                >
                  <FontAwesomeIcon icon={("fas", "info-circle")} />
                </Tooltip>
              </div>
              
            </div>
            <Input
              className="inputCustom drawer-inputCustom"
              value={editable.alias}
              onChange={e => {
                setEditable({...editable, alias: e.target.value});
              }}
              allowClear
              onBlur={() => {
                if (editable.alias) {
                  setModifiedFields({ ...modifiedFields, alias: editable.alias });
                } else {
                  setFieldsToDelete(["alias"]);
                }
              }}
            />
          </div>
        </div>

        <div className="pre-cog-assets-drawer-hr-vertical" >&nbsp;</div>

        <div style={{ display: "flex", flexDirection: "column", width: "50%", gap: 8 }}>
          <div data-testid="groupDescInfo"> <FormattedMessage id={"preCog.assetsTab.drawer.group"} /> <b>{editable.groupDesc}</b> </div>
          <div data-testid="kindDescInfo"> <FormattedMessage id={"preCog.assetsTab.drawer.kind"} /> <b>{editable.kindDesc}</b> </div>
          <div> <FormattedMessage id={"preCog.assetsTab.drawer.subKind"} />
            <Select
              className="pre-cog-assets-drawer-select"
              style={{ width: "100%" }}
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              value={editable.subKind}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={value => {
                setEditable({ ...editable, subKind: value });
                setModifiedFields({ ...modifiedFields, subKind: value });
              }}
            >
              {subkindOptions.map((el, index) => {
                return <Select.Option key={index} value={el.subKind}>
                  {el.description}
                </Select.Option>;
              })}
            </Select></div>
          <div>
            <b>
              {editable.materialGood ?
                <FormattedMessage id={"preCog.assetsTab.drawer.materialGood"} /> :
                <FormattedMessage id={"preCog.assetsTab.drawer.isNonMaterialGood"} />
              }
            </b>
          </div>
          <Radio.Group
            style={{ visibility: !editable.materialGood ? "hidden" : "visible" }}
            value={editable.newGood}
            onChange={e => {
              setEditable({ ...editable, newGood: e.target.value });
              setModifiedFields({ ...modifiedFields, newGood: e.target.value });
            }}
            disabled={readOnly}
            defaultValue={"new"}
          >
            {["new", "used"].map((el, index) =>
              <Radio key={index} className="pre-cog-assets-radio" value={el}><FormattedMessage id={`preCog.assetsTab.drawer.${el}`} /></Radio>)}
          </Radio.Group>
        </div>
      </div>

      <div className="pre-cog-assets-drawer-section" style={{flexDirection: "row"}}>
        <div style={{ width: "100%" }}>
          <div className="precog-withholding-drawer-form—label-text">
            <FormattedMessage id={"preCog.assetsTab.drawer.assetFullDescription"} />
            <div className="precog-withholding-drawer-form—label-tooltip">
            </div>
          </div>
          <Input.TextArea
            maxLength={200}
            className="inputCustom drawer-textArea"
            placeholder="Aggiungi la descrizione"
            value={editableDescription}
            disabled={readOnly}
            showCount={true}
            allowClear
            onBlur={() => {
              
              const descToSave = editableDescription ? fixedDescription + "~" + editableDescription : fixedDescription;
              setEditable({ ...editable, assetFullDescription: descToSave });
              setModifiedFields({ ...modifiedFields, assetFullDescription: descToSave });
            }}
            onChange={e => {
              setEditableDescription(e.target.value);
            }}
          />
          <div className="pre-cog-assets-drawer-subspecies">{fixedDescription}</div>
        </div>
      </div>

      <div className="pre-cog-assets-drawer-section" style={{flexDirection: "row", display: editable.reducedDeductibility === "Fabbricato con terreno" ? "block" : "none"}}>
        <div style={{ width: "100%" }}>
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center", gap: 16, paddingBottom: 8 }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.reducedDeductibilityExtraField"} />
          </div>
          <Input
            className="inputCustom drawer-inputCustom"
            disabled={readOnly}
            defaultValue={editable.reducedDeductibilityExtraField}
            onChange={e => {
              setEditable({...editable, reducedDeductibilityExtraField});
            }}
            onBlur={() => setModifiedFields({ ...modifiedFields, reducedDeductibilityExtraField: editable.reducedDeductibilityExtraField })}
          />
        </div>
      </div>
     
    </>
  );
};

export default FirstRegistryFieldsDrawerFields;
